import { incYenOf, incOf } from '../lib/pricing';
export const financeHero = {
  title: '金融・プライベートバンク向け 法人研修',
  titleEn: 'FOR PRIVATE BANKING & FINANCE',
  lead: '金融向け研修は、富裕層のお客様への所作・距離感・守秘を執事の基準で鍛えるプログラムです。',
};

export const financeTrustBadges = [
  {
    icon: 'ri-shield-user-line',
    text: '仕え方の品質で信頼を築く',
  },
  {
    icon: 'ri-building-4-line',
    text: '出張型で貴社の応接室・会議室にて実施',
  },
  {
    icon: 'ri-user-star-line',
    text: '執事養成課程と同一の講師陣',
  },
];

export const financePainPoints = [
  {
    icon: 'ri-hand-coin-line',
    text: '商品や手数料では差別化しにくく、最後は担当者の人間的な信頼で選ばれます。面談室での所作や会食の段取りは、提案書には表れない実力の差です。',
  },
  {
    icon: 'ri-restaurant-line',
    text: '面談・会食・訪問など「商談の外側」の所作に自信が持てず、せっかくの提案が印象の部分で損なわれているかもしれません。',
  },
  {
    icon: 'ri-key-2-line',
    text: '守秘と距離感を個人の感覚に任せており、担当者によって線引きが異なることが部門全体のリスクになっています。',
  },
  {
    icon: 'ri-user-heart-line',
    text: 'お客様ご本人だけでなく、次世代（二代目・後継者）との関係づくりが課題です。長期的な信頼の土台をどのように築くかが問われています。',
  },
];

export const whyButlerWorks = [
  {
    icon: 'ri-home-smile-line',
    title: '資産家に最も近い職業の作法',
    description:
      '執事は資産家に最も近い場所で信頼を積み上げてきた職業であり、その作法は富裕層営業の作法と地続きです。「仕える」ことを職業として磨かれた技術は、お客様に押し付けがましさを感じさせず、自然な信頼関係を育みます。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '「売る技術」ではなく「仕える技術」を訓練',
    description:
      '当研修が扱うのは商談技法ではありません。所作・距離感・守秘といった、信頼の土台を実技で鍛えます。結果としてお客様が「この人に任せたい」と感じる関係性が、押し付けなく築かれることを狙います。',
  },
  {
    icon: 'ri-tools-line',
    title: '金融研修では扱われにくい領域を補完',
    description:
      '会食の席次判断、お客様宅への訪問時の振る舞い、贈答の作法など、一般的な金融機関の社内研修では扱われにくい領域を実技で補います。提案書の書き方ではなく、提案する「人」の磨き方を提供します。',
  },
];

export const recommendedPrograms = [
  {
    title: '半日プラン例',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    modules: 'M2（VIP・富裕層対応の原則）＋ M3（応接・お茶出し実技）',
    description:
      '富裕層対応の基本原則と応接の実技に集中する短期プランです。まずは管理職が基準を体得する導入研修としてご利用いただけます。',
  },
  {
    title: '1日プラン例',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    modules: 'M1（立ち居振る舞い）＋ M2 ＋ M3 ＋ M4（想定外対応ロールプレイング）',
    description:
      '所作からVIP対応、ロールプレイングまで、富裕層営業の接遇基盤を1日で網羅する推奨プランです。',
    recommended: true,
  },
  {
    title: '役員・支店長向け',
    duration: '半日（3時間）',
    price: incYenOf('ct-single-halfday'),
    modules: '管理職がまず基準を体得し、現場へ展開する形を推奨',
    description:
      '管理職の皆様が先に基準を体得することで、現場への展開がスムーズになります。貴社の会議室1室で実施可能です。',
  },
];

export const financeScenarios = [
  {
    number: '01',
    title: '応接室での面談',
    description:
      'お出迎えからお茶出し、資料の差し出し方、お見送りまでの一連の所作を磨きます。お客様が最初に感じる「この人なら大丈夫」という安心感を、すべての動作に込める技術を習得します。',
    imageSeq: 'finance-scenario-1',
  },
  {
    number: '02',
    title: '会食の段取り',
    description:
      '席次の判断、注文とお支払いのスマートな進め方、会話の距離感をロールプレイングで確認します。お客様に気を遣わせず、それでいて格式を保つ振る舞いを、実践的な演習で身につけます。',
    imageSeq: 'finance-scenario-2',
  },
  {
    number: '03',
    title: 'お客様宅への訪問',
    description:
      '玄関先の振る舞い、手土産の渡し方と渡すタイミング、長居しない引き際の判断まで、訪問時の一連の所作を実技で身につけます。ご家族がいらっしゃる場での距離感も訓練します。',
    imageSeq: 'finance-scenario-3',
  },
];

export const financeTargetRoles = [
  'プライベートバンカー',
  '富裕層担当営業',
  '支店長・管理職',
  '秘書室',
  '受付・ロビー担当',
];

export const financePricingPlans = [
  {
    name: '半日プラン',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    note: '2モジュール選択',
  },
  {
    name: '1日プラン',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    note: '4モジュール選択',
    recommended: true,
  },
  {
    name: '2日間パッケージ',
    duration: '2日間（各6時間）',
    price: incYenOf('ct-single-2day'),
    note: '全モジュール対応',
  },
  {
    name: '継続プログラム',
    duration: '月1回半日×6ヶ月',
    price: incYenOf('ct-advisory-continuous6'),
    note: '定着と改善を繰り返す長期設計',
  },
];

export const financePricingConditions = {
  dispatch: '出張時の交通費は実費別途',
  capacity: '推奨12名まで。超過する場合は2班制等をご提案します',
  payment: 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  cancel: 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
};

export const financeFlowSteps = [
  {
    step: '01',
    title: 'お問い合わせ',
    description: 'フォームまたはお電話・メールにてご連絡ください。',
  },
  {
    step: '02',
    title: 'ヒアリング',
    description:
      '対象層・課題・希望時期などをオンラインまたはお電話で伺います。事前に研修内容資料をお送りすることも可能です。',
  },
  {
    step: '03',
    title: 'プログラム提案・お見積り',
    description:
      'ヒアリング内容をもとに、貴社に最適な研修プログラムとお見積りをご提案します。稟議用の概算お見積りのみのご依頼でも構いません。',
  },
  {
    step: '04',
    title: '実施',
    description:
      '出張または来校にて研修を実施します。出張型では貴社の本社研修室・支店会議室で実施し、役員・支店長向けの少人数セッションは会議室1室で実施可能です。',
  },
  {
    step: '05',
    title: '実施後レポート',
    description: '研修の総括と改善提案をまとめたレポートをお届けします。',
  },
];

export const businessTypeOptions = [
  { value: '', label: '選択してください' },
  { value: 'bank', label: '銀行' },
  { value: 'securities', label: '証券' },
  { value: 'trust', label: '信託' },
  { value: 'insurance', label: '保険' },
  { value: 'other', label: 'その他' },
];

export const financeFormatOptions = [
  { value: '', label: '選択してください' },
  { value: 'dispatch', label: '出張' },
  { value: 'onsite', label: '来校' },
  { value: 'undecided', label: '未定' },
];

export const financeFaqs = [
  {
    question: '執事の資格が取れる研修ですか？',
    answer:
      'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  },
  {
    question: '一般的な営業研修と何が違いますか？',
    answer:
      '売り方ではなく「仕え方」を扱います。所作・距離感・守秘といった信頼の土台を実技で鍛える点が、商談技法中心の営業研修との違いです。',
  },
  {
    question: 'コンプライアンス上、社外研修に出せる内容か確認したいのですが。',
    answer:
      '教材と演習事例はすべて一般化したものを使用し、貴社の顧客情報・商品情報には一切触れません。事前に内容資料をお送りしますのでご確認ください。',
  },
  {
    question: '役員・支店長だけの少人数で実施できますか？',
    answer:
      'はい、可能です。管理職が先に基準を体得し、現場へ展開する形を推奨しています。',
  },
];

export const financeRelatedPages = [
  {
    title: 'ホテル・旅館',
    description: 'バトラーサービスの型を開業前に整える',
    href: '/corporate/hotel',
  },
  {
    title: '高級レジデンス',
    description: 'コンシェルジュ・フロントの接遇品質を統一',
    href: '/corporate/residence',
  },
  {
    title: '百貨店外商・高級小売',
    description: 'お得意様対応と訪問の作法',
    href: '/corporate/retail',
  },
  {
    title: 'ラグジュアリー営業',
    description: '高級車・宝飾・不動産の商談体験を設計',
    href: '/corporate/luxury-sales',
  },
  {
    title: '医療・美容クリニック',
    description: '自由診療の接遇を院内に定着',
    href: '/corporate/clinic',
  },
  {
    title: '自動車・モビリティ',
    description: 'ブランド体験の接遇を高める',
    href: '/corporate/automotive',
  },
  {
    title: 'ハイヤー・送迎',
    description: '乗降の所作と車内の気配りを磨く',
    href: '/corporate/chauffeur',
  },
];